module.exports = __webpack_public_path__ + "img/041.4f469f14.jpg";